import React from 'react'

/**
 * A blinking block cursor using the cursor-blink CSS animation from terminal.css.
 */
export const CursorBlink: React.FC = () => {
  return <span className="cursor-blink">▋</span>
}
